const parseMenuItems = menuItems => {
  let items = []

  if (menuItems) {
    for (let i = 0; i < menuItems.length; i++) {
      if (menuItems[i].parentMenuItemId === 0) {
        items.push({
          id: menuItems[i].id,
          name: menuItems[i].name,
          order: menuItems[i].order,
          parentMenuItemId: menuItems[i].parentMenuItemId,
          children: findChildren(menuItems, menuItems[i].id),
          status: ''
        })
      }
    }
  }

  return sort(items)
}
let sort = items => {
  items.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0))
  return items
}
let findChildren = (menuItems, parentId) => {
  let children = []

  for (let i = 0; i < menuItems.length; i++) {
    if (menuItems[i].parentMenuItemId === parentId) {
      children.push({
        id: menuItems[i].id,
        name: menuItems[i].name,
        order: menuItems[i].order,
        parentMenuItemId: menuItems[i].parentMenuItemId,
        children: findChildren(menuItems, menuItems[i].id),
        status: ''
      })
    }
  }
  return sort(children)
}

const filterMenuItems = (term, items) => {
  var exp = new RegExp(term, 'i')
  var activeMenuIds = []

  function deepFilter(children) {
    return children.filter(function(item) {
      let result = exp.test(item.name)
      item.children = deepFilter(item.children)
      if (item.children.length > 0 && term !== '') {
        activeMenuIds.push(item.id)
        localStorage.menuItemsTreeState = activeMenuIds.toString()
      }
      if (item.children.length > 0) {
        return true
      }
      if (!result || result === -1 || result.length === 0) {
        return false
      } else {
        return true
      }
    })
  }
  return deepFilter(items)
}

const filterLinkedItems = (linkedItems, items) => {
  if (linkedItems.length == 0) {
    return items
  }

  let filtered = []
  let linkedIds = linkedItems.map(element => {
    return element.id
  })
  let ids = items.map(element => {
    return element.id
  })
  let filteredId = ids.filter(element => !linkedIds.includes(element))
  for (let i = 0; i < items.length; i++) {
    let found = false
    for (let j = 0; j < linkedItems.length; j++) {
      if (items[i].id === linkedItems[j].id) {
        found = true
      }
    }
    if (!found) filtered.push(items[i])
  }
  return filtered
}

export default {
  parseMenuItems,
  filterMenuItems,
  filterLinkedItems
}
